import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import {
  BGColor02,
  blackShade19,
  blueColor04,
  greyColor9,
  redColor,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import ErrorIcon from "@mui/icons-material/Error";
import ModalCard from "../../../components/ModalCard";
import { toTitleCase } from "../../../utils/validationUtils";
import TableCellDropdownBox from "../../../components/TableInputs/TableCellDropdownBox";
import TabelCellInputBox from "../../../components/TableInputs/TabelCellInputBox";
import { DEFAULT_COUNTRY } from "../../../utils/data";

const BulkUpdateProductInfo = ({
  openModal,
  setOpenModal,
  productDetails,
  selectedRowCount,
  countryList,
  gstRates,
  unitOfMeasurementData,
  updateLoader,
  updateProducts,
}) => {
  const [productInfo, setProductInfo] = useState({
    selectedCountry: "",
    gstPercentage: null,
    minOrderQuantity: "",
    maxOrderQuantity: "",
    alertQuantity: "",
    unitOfmeasurement: "",
  });
  const [errorMsg, setErrorMsg] = useState(null);

  const handleValueChange = (key, value) => {
    if (key === "maxOrderQuantity") {
      setProductInfo((prevState) => ({
        ...prevState,
        [key]: value,
        alertQuantity: Number(value) * 3,
      }));

      setErrorMsg((prevState) => ({
        ...prevState,
        [key]: "",
      }));

      return;
    }

    setProductInfo((prevState) => ({
      ...prevState,
      [key]: value,
    }));

    setErrorMsg((prevState) => ({
      ...prevState,
      [key]: "",
    }));
  };

  const onApply = () => {
    const productList = [...productDetails];
    const updatedList = productList?.map((item) => {
      if (item?.isSelected) {
        return {
          ...item,
          origin: productInfo?.selectedCountry || DEFAULT_COUNTRY,
          gstInfo: {
            code: "",
            gstPercentage: productInfo?.gstPercentage?.value || item?.gstInfo?.gstPercentage || "",
          },
          minOrderQuantity: productInfo?.minOrderQuantity || item?.minOrderQuantity,
          maxOrderQuantity: productInfo?.maxOrderQuantity || item?.maxOrderQuantity,
          alertQuantity: productInfo?.alertQuantity || item?.alertQuantity,
          unitOfmeasurement: productInfo?.unitOfmeasurement || item?.unitOfmeasurement,
        };
      } else {
        return item;
      }
    });

    console.log("ON_APPLY___:", { productInfo, updatedList });
    updateProducts(updatedList);
    setOpenModal(false);
  };

  return (
    <ModalCard
      open={openModal}
      handleClose={() => {
        setOpenModal(false);
      }}
      width="40%"
    >
      <Box sx={{ backgroundColor: whiteColor, borderRadius: 1.8 }}>
        <Box
          sx={{
            backgroundColor: BGColor02,
            p: 1.5,
            borderRadius: "14.4px 14.4px 0 0",
            textAlign: "center",
          }}
        >
          <Typography
            variant="body1"
            fontSize={16}
            fontWeight={600}
            color={blackShade19}
            mb={0.3}
          >
            Quick Product Info Update{" "}
            <Typography
              variant="body1"
              fontSize={13}
              fontWeight={500}
              color={greyColor9}
            >
              <span
                style={{
                  fontSize: "13px",
                  fontWeight: 600,
                  color: blueColor04,
                }}
              >
                {selectedRowCount} of {productDetails?.length}
              </span>{" "}
              rows selected
            </Typography>
          </Typography>
        </Box>

        <Box sx={{ p: 2, mb: 1 }}>
          {/* <Typography
              variant="h6"
              fontSize={14}
              fontWeight={600}
              color={blackShade19}
              mb={1}
            >
              ONDC Categories
            </Typography> */}

          <Grid container spacing={3}>
            <Grid item md={6}>
              <Typography variant="body1" sx={styles.inputLabel}>
                Country 
              </Typography>

              <TableCellDropdownBox
                value={productInfo?.selectedCountry?.name || "Select Country"}
                onValueChange={(value) => {
                  handleValueChange("selectedCountry", value);
                }}
                returnFullItem
                menuList={[{ name: "Select Country" }, ...countryList]}
                valueSelector="name"
                borderFull
                rounded
                required
                width="100%"
              />

              <ErrorText errorMsg={errorMsg?.selectedCountry} />
            </Grid>

            <Grid item md={6}>
              <Typography variant="body1" sx={styles.inputLabel}>
                GST % 
              </Typography>

              <TableCellDropdownBox
                value={productInfo?.gstPercentage?.value || "Select GST %"}
                onValueChange={(value) => {
                  handleValueChange("gstPercentage", value);
                }}
                returnFullItem
                menuList={[{ value: "Select GST %" }, ...gstRates]}
                valueSelector="value"
                borderFull
                rounded
                required
                width="100%"
              />

              <ErrorText errorMsg={errorMsg?.gstPercentage} />
            </Grid>

            <Grid item md={6}>
              <Typography variant="body1" sx={styles.inputLabel}>
                Min Qty Per Order 
              </Typography>

              <TabelCellInputBox
                value={productInfo?.minOrderQuantity}
                onValueChange={(value) => {
                  handleValueChange("minOrderQuantity", value);
                }}
                regexType="qty"
              />

              <ErrorText errorMsg={errorMsg?.minOrderQuantity} />
            </Grid>

            <Grid item md={6}>
              <Typography variant="body1" sx={styles.inputLabel}>
                Max Qty Per Order 
              </Typography>

              <TabelCellInputBox
                value={productInfo?.maxOrderQuantity}
                onValueChange={(value) => {
                  handleValueChange("maxOrderQuantity", value);
                }}
                regexType="qty"
              />

              <ErrorText errorMsg={errorMsg?.maxOrderQuantity} />
            </Grid>

            {/* <Grid item md={6}>
              <Typography variant="body1" sx={styles.inputLabel}>
                Alert Qty
              </Typography>

              <TabelCellInputBox
                value={productInfo?.alertQuantity}
                onValueChange={(value) => {
                  handleValueChange("alertQuantity", productInfo?.alertQuantity);
                }}
                regexType="qty"
                disabled
              />
            </Grid> */}

            <Grid item md={6}>
              <Typography variant="body1" sx={styles.inputLabel}>
                Unit of Measurement 
              </Typography>

              <TableCellDropdownBox
                value={
                  productInfo?.unitOfmeasurement
                    ? toTitleCase(productInfo?.unitOfmeasurement)
                    : "Select Unit Of Measurement"
                }
                onValueChange={(value) => {
                  handleValueChange("unitOfmeasurement", value);
                }}
                menuList={[
                  { value: "Select Unit Of Measurement" },
                  ...unitOfMeasurementData?.map((item) => ({
                    ...item,
                    value: toTitleCase(item?.value),
                  })),
                ]}
                valueSelector="value"
                borderFull
                rounded
                width="100%"
              />

              <ErrorText errorMsg={errorMsg?.unitOfmeasurement} />
            </Grid>
          </Grid>
        </Box>

        <Stack
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          gap={4}
          sx={{
            backgroundColor: BGColor02,
            p: 2,
            borderRadius: "0 0 14.4px 14.4px",
          }}
        >
          <Button
            variant="contained"
            sx={styles.backBtn}
            disableElevation
            onClick={() => {
              setOpenModal(false);
            }}
          >
            CANCEL
          </Button>

          <Button
            variant="contained"
            disableElevation
            sx={styles.applyBtn}
            onClick={() => {
              onApply();
            }}
            startIcon={
              updateLoader ? (
                <CircularProgress color="inherit" size={14} />
              ) : null
            }
          >
            Apply To{" "}
            {selectedRowCount === 1
              ? `${selectedRowCount} Row`
              : `${selectedRowCount} Rows`}
          </Button>
        </Stack>
      </Box>
    </ModalCard>
  );
};

export default BulkUpdateProductInfo;

const ErrorText = ({ errorMsg }) => {
  if (!errorMsg) return null;

  return (
    <Typography
      variant="body1"
      fontSize={11.5}
      fontWeight={500}
      color={redColor}
      mt={0.4}
    >
      <ErrorIcon sx={{ fontSize: 13, mr: 0.3, mt: -0.3 }} /> {errorMsg}
    </Typography>
  );
};

const styles = {
  backBtn: {
    fontSize: 12,
    fontWeight: 500,
    backgroundColor: whiteColor,
    border: `1px solid ${blackShade19}`,
    color: blackShade19,
    p: "5px 20px",
    "&:hover": {
      color: blackShade19,
      backgroundColor: whiteColor,
    },
  },

  applyBtn: {
    fontSize: 12,
    fontWeight: 500,
    backgroundColor: blueColor04,
    border: `1px solid ${blueColor04}`,
    color: whiteColor,
    p: "5px 20px",
    "&:hover": {
      color: blueColor04,
      backgroundColor: whiteColor,
    },
  },

  uncheckBtn: {
    fontSize: 13,
    fontWeight: 500,
    border: `1.5px solid ${blueColor04}`,
    color: blueColor04,
    p: "4px 30px",
    "&:hover": {
      color: whiteColor,
      backgroundColor: blueColor04,
      border: `1.5px solid ${blueColor04}`,
    },
  },

  requiredStar: { fontSize: 12, color: redColor },

  deleteBtn: {
    border: `1.5px solid ${redColor}`,
    backgroundColor: redColor,
    "&:hover": {
      color: redColor,
      backgroundColor: whiteColor,
    },
  },

  inputLabel: {
    fontSize: 12,
    fontWeight: 400,
    mb: 1,
  },
};
